import { Factory } from 'fishery';
import { User } from '@trukt/types/User';

export const userFactory = Factory.define<User>(({ sequence }) => ({
  guid: sequence.toString(),
  name: 'Alice Smith',
  phoneNumber: '555-123-4567',
  mobileNumber: '555-987-6543',
  email: 'alicesmith@gmail.com',
  canLogin: true,
  role: { guid: '4', name: 'user', description: '', isActive: true },
}));
